import { useExperimentalQuery } from '@confluence/legacy-schema-bridge/entry-points/useExperimentalQuery.ts';
import { MediaType } from '@confluence/graphql/entry-points/MediaType.ts';

import type {
	SuggestedCollaboratorsDialogInvitePermissionsQuery as SuggestedCollaboratorsDialogInvitePermissionsQueryData,
	SuggestedCollaboratorsDialogInvitePermissionsQueryVariables,
} from './__types__/SuggestedCollaboratorsDialogInvitePermissionsQuery.ts';

type DirectInviteMode = 'ANYONE' | 'DOMAIN_RESTRICTED' | 'NONE';
type InvitePendingApprovalMode = 'ANYONE' | 'NONE';

type InviteCapabilitiesItem = {
	resourceARI?: string;
	directInvite?: {
		mode?: DirectInviteMode;
		domains?: string[];
	};
	invitePendingApproval?: {
		mode?: InvitePendingApprovalMode;
	};
};

type InviteCapabilitiesResponse = InviteCapabilitiesItem[];

export const useExperimentalInvitePermissionsQuery = ({
	variables,
	skip,
}: {
	variables: SuggestedCollaboratorsDialogInvitePermissionsQueryVariables;
	skip?: boolean;
}) => {
	return useExperimentalQuery<
		SuggestedCollaboratorsDialogInvitePermissionsQueryData,
		SuggestedCollaboratorsDialogInvitePermissionsQueryVariables,
		InviteCapabilitiesResponse
	>({
		url: `/gateway/api/v3/invitations/capabilities?resource=${variables.resourceARI}`,
		method: 'GET',
		credentials: 'include',
		headers: {
			'Content-Type': MediaType.JSON,
		},
		parseResult: (response: InviteCapabilitiesResponse) => {
			for (const item of response) {
				if (item?.resourceARI?.includes('confluence')) {
					return {
						experimentalInvitePermissions: {
							directInviteMode: item?.directInvite?.mode ?? null,
							invitePendingApprovalMode: item?.invitePendingApproval?.mode ?? null,
						},
					};
				}
			}
			return {
				experimentalInvitePermissions: {
					directInviteMode: null,
					invitePendingApprovalMode: null,
				},
			};
		},
		variables,
		skip,
	});
};
